import {Injectable} from "@angular/core";
import {JwtHttpClientService} from "../http/jwt-http-client.service";
import {NotificationData} from "./notification.data";
import {HttpResponse} from "@angular/common/http";
import {firstValueFrom, map} from "rxjs";
import {EntityData} from "../resource/entity/entity.data";

@Injectable()
export class NotificationService {

    public static readonly URL_PREFIX = '/dataserver/notification/';
    public static readonly SEARCH_PREFIX = 'search/';
    public static readonly UNSEENCOUNT_PREFIX = 'unseenCount/';
    public static readonly MARK_VIEWED_PREFIX = 'viewed/';

    constructor(protected http: JwtHttpClientService) {
    }

    /**
     * Search notifications
     * @returns {Promise<NotificationData[]>}
     */
    public searchNotifications(): Promise<NotificationData[]> {
        return firstValueFrom(this.http.get(NotificationService.URL_PREFIX + NotificationService.SEARCH_PREFIX).pipe(
            map((response: HttpResponse<Object>) => <NotificationData[]> EntityData.createArray(response.body, NotificationData))
        ));
    }

    public getUnseenCount(): Promise<number> {
        return firstValueFrom(this.http.get(NotificationService.URL_PREFIX + NotificationService.UNSEENCOUNT_PREFIX, undefined, undefined, "text").pipe(
            map((response: HttpResponse<string>) => parseInt(response.body))
        ));
    }

    public markAsViewed(identifier: String): Promise<any> {
        return firstValueFrom(this.http.get(NotificationService.URL_PREFIX + NotificationService.MARK_VIEWED_PREFIX + identifier).pipe(
            map(() => undefined)
        ));
    }

    public deleteNotification(identifier: String): Promise<any> {
        return firstValueFrom(this.http.delete(NotificationService.URL_PREFIX + identifier).pipe(
            map(() => undefined)
        ));
    }
}
